import storage from 'utils/storage'
import jsCookie from 'js-cookie'
import uuid from 'uuid/v4'

function getDeviceId() {
  let deviceId = storage.get('device_id')
  if (deviceId) return deviceId
  deviceId = uuid()
  jsCookie.set('device_id', deviceId, { expires: 30 })
  storage.set('device_id', deviceId)
  return deviceId
}

export default getDeviceId
